import React from 'react';
import * as Icon from 'react-feather';

const ContactInfo = () => {
    return (
        <div className="contact-info-area ptb-80">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="contact-info-box">
                            <div className="icon">
                                <Icon.Mail />
                            </div>
                            <h3>Mailimiz</h3>
                            <p>finans@pixelyazilim.com.tr</p>
                                </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="contact-info-box">
                            <div className="icon">
                                <Icon.MapPin />
                            </div>
                            <h3>Buradayız</h3>
                            <p>Fevziçakmak, Aslım Cd. No:92, 42080 Karatay/Konya</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="contact-info-box">
                            <div className="icon">
                                <Icon.Phone />
                            </div>
                            <h3>Arayabilirsiniz</h3>
                            <p>+90 541 938 82 98</p>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactInfo;  